var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63606 3.63606C4.47179 2.80032 5.46395 2.13738 6.55588 1.68509C7.64782 1.23279 8.81815 1 10.0001 1C11.182 1 12.3523 1.23279 13.4442 1.68509C14.5362 2.13738 15.5283 2.80032 16.3641 3.63605C17.1998 4.47179 17.8627 5.46395 18.315 6.55588C18.7673 7.64782 19.0001 8.81815 19.0001 10.0001C19.0001 11.182 18.7673 12.3523 18.315 13.4442C17.8627 14.5362 17.1998 15.5283 16.3641 16.3641C14.6762 18.0519 12.387 19.0001 10.0001 19.0001C7.61309 19.0001 5.32389 18.0519 3.63606 16.3641C1.94822 14.6762 1 12.387 1 10.0001C1 7.61309 1.94822 5.32389 3.63606 3.63606V3.63606Z",
    stroke: "#E53935",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4L16 16",
    stroke: "#E53935",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMessageIcon);
export default __webpack_public_path__ + "static/media/error-message-icon.aefee799c6a327d44bc09b902ac61b23.svg";
export { ForwardRef as ReactComponent };